import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', function (e) {
    const jsReviewsSlider = e.target.querySelector('.js-reviews-slider')

    if (jsReviewsSlider) {
        const splideInstanceReviews = new Splide(jsReviewsSlider, {
            perPage: 3,
            type: 'loop',
            drag: 'free',
            arrows: false,
            pagination: false,
            gap: '30px',
            autoScroll: {
                speed: .3,
            },
            breakpoints: {
                991: {
                    perPage: 1,
                },
            },
        })
        splideInstanceReviews.mount( { AutoScroll } )
    }
})
